<template>
  <div class="container d-flex align-content-center flex-wrap justify-content-center" style="height: 100vh" @click.self="$one?.context.closePlugin()">
    <div>
      <div v-if="$one && $one.isInitialized">
        <div class="popup">
          <component :is="selectedComponent" />
        </div>
      </div>
      <div v-else-if="$one">
        Loading
      </div>
      <div v-else>
        Initializing...
      </div>
    </div>
  </div>
</template>

<style>
  .popup {
    background-color: white;
    border-width: 15px;
    border-style: solid;
    border-color: darkgrey;
    border-radius: 35px;
    padding: 0px 10px;
    width: 400px;
    height: 600px;
  }
  h5 {
    font-size: large !important;
  }
</style>

<script>

import QuantityDiscountComponent from "./components/QuantityDiscount.vue";
import DiscountRouterComponent from "./components/DiscountRouter.vue";

const routes = {
  "/": null,
  "/#app-add-to-cart": DiscountRouterComponent,
  "/#app-edit-cart": QuantityDiscountComponent,
}

export default {
  name: "MyPlugin",
  components: {
  },
  methods: {
    onLocationChanged() {
      this.currentPath = window.location.hash;
    },
    updateToken() {
      this.$one.authorization.getAuthToken().then((token) => {
        this.$one.token = token;
      });
    },
    afterONeInitialized() {
      this.tokenInterval = setInterval(this.updateToken, 2*60*1000); this.updateToken();
    }
  },
  computed: {
    selectedComponent() {
      let route = this.currentPath.split("?")[0] || "/";
      if (!route.startsWith("/")) route = "/" + route;
      return routes[route] || routes["/"];
    }
  },
  data() {
    return {
      /** @type {import('@one-commerce/sdk-core').ShopSdk} */
      $one: null,
      /** @type {String} */
      currentPath: window.location.hash,
      /** @type {NodeJS.Timeout} */
      tokenInterval: null,
    }
  },
  mounted() {
    window.addEventListener("hashchange", this.onLocationChanged);
    window.addEventListener("load", () => {
      this.$one = this.initializeONe();
      this.$watch("$one.isInitialized", this.afterONeInitialized);
    });
  },
  unmounted() {
    window.removeEventListener("hashchange", this.onLocationChanged);
    clearInterval(this.tokenInterval);
  },
  watch: {
  }
}
</script>

<style>

</style>